// Fonts (SIL OFL 1.1, bundled with the app, no CDN): Barlow Condensed for headings,
// buttons and captions, Atkinson Hyperlegible Next for text, IBM Plex Mono for numbers.
import "@fontsource/barlow-condensed/latin-600.css";
import "@fontsource/barlow-condensed/latin-700.css";
import "@fontsource/barlow-condensed/latin-ext-600.css";
import "@fontsource/barlow-condensed/latin-ext-700.css";
import "@fontsource/atkinson-hyperlegible-next/latin-400.css";
import "@fontsource/atkinson-hyperlegible-next/latin-700.css";
import "@fontsource/atkinson-hyperlegible-next/latin-ext-400.css";
import "@fontsource/atkinson-hyperlegible-next/latin-ext-700.css";
import "@fontsource/ibm-plex-mono/latin-400.css";
import "@fontsource/ibm-plex-mono/latin-500.css";
import "@fontsource/ibm-plex-mono/latin-ext-400.css";
import "@fontsource/ibm-plex-mono/latin-ext-500.css";
import "@fontsource/ibm-plex-mono/cyrillic-400.css";
import "@fontsource/ibm-plex-mono/cyrillic-500.css";
import { createI18n } from "@szerviz/i18n";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import { App } from "./App";
import { createStore, detectAuthIntent } from "./data";
import { initialLanguage } from "./language";

const i18n = createI18n(initialLanguage());
document.documentElement.lang = i18n.language;
// Read before the cloud client consumes the link parameters in the address.
const authIntent = detectAuthIntent(location.hash, location.search);
const store = createStore();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <App store={store} authIntent={authIntent} />
    </I18nextProvider>
  </StrictMode>,
);

// Android offers installing; keep the offer for the "home screen" button.
addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  (globalThis as { installPrompt?: Event }).installPrompt = e;
  dispatchEvent(new Event("szerviz-installable"));
});

// Installable on phones (home screen icon, full screen). Only in the built app.
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  addEventListener("load", () => void navigator.serviceWorker.register("/sw.js").catch(() => undefined));
}
